<template>
  <div class="domain-settings">
    <Modal
      v-model="openModal"
      :title="$t('generic.cancel_form_modal_title')"
      :subtitle="$t('generic.cancel_form_modal_subtitle')"
      :cta-text="$t('generic.cancel_form_modal_cta_text')"
      @confirm="leavePage"
      @cancel="cancelLeavePage">
    </Modal>
    <div class="domain-settings__actions d-flex">
      <v-btn @click="cancelButtonHandler" class="ml-auto cancel__btn" color="primary" outlined>
        {{ $t("generic.buttons.cancel") }}
      </v-btn>
      <v-btn @click="$refs.domainForm.submit()" color="primary">
        {{ $t("generic.buttons.save") }}
      </v-btn>
    </div>
    <DomainForm edit-form @isDirtyForm="isDirtyForm" ref="domainForm" :domain="domain"></DomainForm>
    <div class="d-flex mt-6">
      <v-btn @click="cancelButtonHandler" class="ml-auto cancel__btn" color="primary" outlined>
        {{ $t("generic.buttons.cancel") }}
      </v-btn>
      <v-btn @click="$refs.domainForm.submit()" color="primary">
        {{ $t("generic.buttons.save") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
  import DomainForm from "@/components/forms/DomainForm";
  import resourceCreateAndEditActions from "@/mixins/resourceCreateAndEditActions";
  import Modal from "@/components/custom/Modal.vue";
  import { eventBus } from "@/event-bus";
  import { goBack } from "@/utility/goBack";
  import { mapActions } from "vuex";

  export default {
    name: "DomainSettings",
    components: {
      DomainForm,
      Modal,
    },
    mixins: [resourceCreateAndEditActions],
    props: {
      domain: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        openModal: false,
        currentRoute: this.$route,
        redirectRouteName: "",
        logoutActive: false,
      };
    },
    mounted() {
      window.addEventListener("beforeunload", this.beforeUnloadAction);

      eventBus.$on("open-exit-modal", (data, logout) => {
        this.redirectRouteName = data;
        this.popstateEventAction(undefined, logout);
      });

      window.addEventListener("popstate", this.popstateEventAction);
    },
    beforeDestroy() {
      window.removeEventListener("popstate", this.popstateEventAction);
      window.removeEventListener("beforeunload", this.beforeUnloadAction);
      this.removePopstateEventAction();
      eventBus.$off("open-exit-modal");
    },
    watch: {
      showModal: function (newVal) {
        if (newVal === true) {
          this.currentRoute.meta.disableRedirect = true;
        } else {
          this.currentRoute.meta.disableRedirect = false;
        }
      },
    },
    methods: {
      ...mapActions({
        logout: "auth/logout",
      }),
      beforeUnloadAction(event) {
        if (this.showModal) {
          event.returnValue = true;
        }
      },
      popstateEventAction(_, logout) {
        if (this.showModal) {
          this.openModal = true;
          if (logout) {
            this.logoutActive = true;
          }
        } else if (logout) {
          this.logout();
        }
      },
      removePopstateEventAction() {
        window.removeEventListener("popstate", this.popstateEventAction);
      },
      leavePage() {
        this.currentRoute.meta.disableRedirect = false;

        this.removePopstateEventAction();

        if (this.logoutActive) {
          this.logout();

          return;
        }

        if (this.redirectRouteName) {
          this.$router.push({ name: this.redirectRouteName });
        } else {
          goBack(this.$router);
        }
      },
      cancelLeavePage() {
        this.logoutActive = false;
      },
      cancelButtonHandler() {
        if (this.showModal) {
          this.openModal = true;
        } else {
          goBack(this.$router);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../../@core/preset/preset/functions.scss";
  @import "../../../@core/preset/preset/typography/index.scss";

  .domain-settings {
    &__actions {
      margin: 26px 0px;
      button {
        &:first-child {
          margin-right: 16px;
        }
      }
    }
  }

  .cancel__btn {
    margin-right: 16px;
  }
</style>
